import React from "react";
import {
	Link as RouterLink,
	LinkProps as RouterLinkProps,
	//useMatch
} from "react-router-dom";
import { useTranslation } from "react-i18next"
import { Link, LinkProps } from "@mui/material";
import { useI18n } from "@haohan/root-locales";

export type SiteRouterLinkProps = RouterLinkProps & LinkProps & {
	to: string,
	lang?: string
};

const LinkComponent = React.forwardRef<HTMLAnchorElement, SiteRouterLinkProps>((props, ref) => {
	return (
		<RouterLink {...props} ref={ref}>
			{props.children}
		</RouterLink>
	);
});

export const SiteRouterLink = React.forwardRef<HTMLAnchorElement, SiteRouterLinkProps>((props, ref) => {
	const {
		children,
		to,
		...linkProps
	} = props;
	const i18n = useI18n();
	const lang = props.lang ?? i18n.lang;
	let href = '';
	if (to.startsWith(`/${lang}/`)) {
		href = to;
	} else {
		href = `/${lang}`;
		if (!to.startsWith('/')) {
			href += '/';
		}
		href += to;
	}
	return (
		<Link
			component={LinkComponent as any}
			ref={ref}
			to={href}
			{...linkProps}
		>
			{children}
		</Link>
	);
});
